import { render, staticRenderFns } from "./InsightsTableRow.vue?vue&type=template&id=3fe01d10&scoped=true&"
import script from "./InsightsTableRow.vue?vue&type=script&lang=js&"
export * from "./InsightsTableRow.vue?vue&type=script&lang=js&"
import style0 from "./InsightsTableRow.vue?vue&type=style&index=0&id=3fe01d10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe01d10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VHover,VIcon,VRow})
